import { render, staticRenderFns } from "./Orders.vue?vue&type=template&id=53042f42"
import script from "./Orders.vue?vue&type=script&lang=js"
export * from "./Orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('53042f42')) {
      api.createRecord('53042f42', component.options)
    } else {
      api.reload('53042f42', component.options)
    }
    module.hot.accept("./Orders.vue?vue&type=template&id=53042f42", function () {
      api.rerender('53042f42', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/Orders.vue"
export default component.exports